// Gatsby browser code
// You can also wrap with TSX components like so
import { WrapRootElement } from './src/components/wrapRootElement';

import '@repo/ui/src/theme/theme.scss';

export const wrapRootElement = WrapRootElement;
